import axios from 'axios'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  dummyUsername:'',
  dummyPassword:'',
  dummyFullName:'',
  dummyFirstName:'',
  dummyFatherName:'',
  dummyGrandFatherName:'',
  dummyEmailAddress:'',
  dummyZoneSubcity:'Sample Zone',
  dummyWoreda:'Sample Woreda',
  dummyKebele:'Sample Kebele',
  dummyHouseNumber:'Sample House Number',
  dummySalary:'123456',
  dummyPosition:'Sample Position',

  dummyTitle:'Sample Title',
  dummyName:'Sample Name',
  dummyDescription:'Sample Description',
  dummyVenue:'Sample Venue',

  dummyContactId:'Sample Contact ID',

  dummyAddress:'Sample Address',

  dummySubject:'Sample Subject',
  dummyBody:'Sample Body',

  dummyContentLink:'Sample Content Link',
  dummyTopic:'Sample Topic',

  dummyVerificationNumber:'912622985',

  cached: [],

  serverUrl:'http://localhost:3000'
}

export const mutations = {
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
  SET_CURRENT_USER(state, newValue) {
    //console.log("From SET_CURRENT_USER: "+JSON.stringify(newValue))
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  getCurrentUser(state) {
    return state.currentUser
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    //console.log('>>>>>>>>>>>>>>>>>>>> login:'+ axios.defaults.baseURL)
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/session', { username, password })
      .then((response) => {
        const user = response.data
        if (user.isVerified && user.dataComplete)
        {
          //console.log('>>>>>>>>>>>>>>>>>>>> isVerified and isData Complete: '+ user.isVerified +' | '+ user.dataComplete)
          //console.log('>>>>>>>>>>>>>>>>>>>> User is: '+ JSON.stringify(user)+'|'+user.password)
          commit('SET_CURRENT_USER', user)
        }
        return user
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // register the user
  register({ commit, dispatch, getters }, { fullname, phoneNumber, password, courseList, sex, ageGroup, occupation, employedOccupation } = {}) {
    if (getters.loggedIn) return dispatch('validate')
    //console.log('>>>> GOT IN HERE: fullname: '+fullname)
    return axios
      .post('/api/register', { fullname, phoneNumber, password, courseList, sex, ageGroup, occupation, employedOccupation })
      .then((response) => {

        const user = response.data
        //console.log('>>>> GOT IN HERE: '+user.id)
        return user
      })
  },

  // register the user
  resetPassword({ commit, dispatch, getters }, { contactNumber } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios.post('/api/reset', { contactNumber }).then((response) => {
      const message = response.data
      return message
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    console.log('>>>>>>>>>>>>>>>>>>>> validate: '+axios.defaults.baseURL)
    if (!state.currentUser) return Promise.resolve(null)

    return axios
      .get('/api/session')
      .then((response) => {
        const user = response.data
        console.log('>>>>>>>>>>>>>>>>>>>> ALL WENT WELL: '+user.username)
        commit('SET_CURRENT_USER', user)
        return user
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log('>>>>>>>>>>>>>>>>>>>> ERROR OCCURRED: '+JSON.stringify(error.response))
          commit('SET_CURRENT_USER', null)
        }
        return null
      })
  },

  saveUser({ commit, state }, {user} = {}) {
    //console.log("From SaveUser: "+JSON.stringify(user))
    commit('SET_CURRENT_USER', user)
    //commit('CACHE_USER', user)
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  //console.log('>>>>>> USER: '+window.localStorage.getItem(key))
  //if(window.localStorage.getItem(key)!='undefined')
  return JSON.parse(window.localStorage.getItem(key))
  //else
  //return null
}

function saveState(key, state) {
  //console.log("From Savestate: "+JSON.stringify(state))
  window.localStorage.setItem(key, JSON.stringify(state))
  //console.log('From getSavedState: '+JSON.stringify(getSavedState(key)))
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.token
    : ''
}
